/**
 * Utilitaire pour précharger une image
 * Retourne une Promise qui se résout quand l'image est chargée
 */
export function preloadImage(src) {
  return new Promise((resolve, reject) => {
    if (!src) {
      reject(new Error('No image source provided'));
      return;
    }

    const img = new Image();
    
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
    
    // Commencer le chargement
    img.src = src;
  });
}

/**
 * Précharge plusieurs images en parallèle
 */
export function preloadImages(sources) {
  return Promise.allSettled(
    sources.map(src => preloadImage(src))
  );
}

/**
 * Précharge uniquement les images légères critiques au démarrage
 * Les images lourdes (>1MB) sont chargées en lazy loading pour éviter les blocages
 */
export function preloadCriticalBackdrops() {
  // Ne précharger que les images légères (hero-bg est généralement plus petite)
  // Les images lourdes (bg-wave.jpg 10.5MB, bg-sea-wave.jpg 3.9MB) sont chargées en lazy loading
  const criticalImages = [
    '/images/hero-bg.jpg', // Image hero généralement plus légère
  ];

  // Précharger en arrière-plan sans bloquer
  preloadImages(criticalImages).catch(err => {
    console.warn('Some backdrop images failed to preload:', err);
  });
}
